<mat-selection-list
  disableRipple="true"
  [ngClass]="listClass"
  [formControl]="control"
  (selectionChange)="selectionChange.emit($event)"
>
  <h3 matSubheader>{{ header }}</h3>
  <mat-list-option
    *ngFor="let option of options"
    [value]="option.value"
    (click)="$event.stopPropagation()"
    [ngClass]="optionClass"
  >
    <div class="filter-text">
      <span>{{ option.label }}</span>
      <span class="info-label" *ngIf="isBeta(option.value)">BETA</span>
    </div>
  </mat-list-option>
</mat-selection-list>
